import type { DataTableRow } from 'carbon-components-svelte/src/DataTable/DataTable.svelte';

import { toCsv, type CsvColumn } from '../../../shared/csv';
import type { ExportColumnOption, TableColumn } from './table-types';

export type CsvCellFormatter = (row: DataTableRow, header: { key: string }) => unknown;

export const getExportableColumns = (headers: TableColumn[]): ExportColumnOption[] =>
  headers
    .filter(
      (header): header is TableColumn & { key: string; value: string } =>
        'value' in header && Boolean(header.value) && header.exportable !== false
    )
    .map((header) => ({ key: header.key, label: header.csvHeader ?? String(header.value) }));

export const buildCsv = (
  columns: ExportColumnOption[],
  rows: DataTableRow[],
  selectedKeys: string[],
  formatCell: CsvCellFormatter
): string => {
  const selected = columns.filter((column) => selectedKeys.includes(column.key));
  const csvColumns: CsvColumn[] = selected.map((column) => ({ header: column.label, path: column.key }));
  const records = rows.map((row) => {
    const record: Record<string, unknown> = {};
    for (const column of selected) {
      record[column.key] = formatCell(row, { key: column.key });
    }

    return record;
  });

  return toCsv(records, csvColumns);
};
